import React, { useState } from 'react';
import { Form } from '../form/form';
import styles from './clientForm.module.scss';
import { FormProvider, useForm } from 'react-hook-form';
import ClientCard from '../clientCard/clientCard';
import { Fieldset } from '../fieldSet/fieldSet';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '../button/button';
import { TextInput } from '../form/textInput';
import { ImageUpload } from '../imageUpload/imageUpload';
import { Quil } from '../form/quil';
import { SelectInput } from '../form/selectInput';
import dataService from '../../services/dataService';

export const ClientForm = (props) => {
  const { loading, clientData, yupSchema, isEdit, state, setState } = props;

  const [initialValues] = useState(() => {
    return dataService.parseFormDataForClientEdit(clientData);
  });
  const form = useForm({
    resolver: yupResolver(yupSchema),
    mode: 'all',
    defaultValues: initialValues,
  });

  const handleSubmitForm = (values) => {
    props.createClient({ body: values });
  };

  return (
    <div>
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(handleSubmitForm)}
          className={styles.clientFormContainer}
          actions={[
            <Button type="submit" id="clientSubmitBtn" submit inline disabled={loading}>
              {isEdit ? 'Save changes' : 'Create client profile'}
            </Button>,
          ]}
        >
          <div className="row g-0">
            <div className="col-lg-4 col-12 mx-0 px-0">
              <ClientCard
                client={initialValues}
                onLogoClick={() => {
                  '';
                }}
                onCoverClick={''}
                isEditable={true}
                standalone={false}
                state={state}
              />
            </div>
            <div className="col-lg-8 p-0">
              <Fieldset
                title="Hotel details"
                description="The client profile is displayed on all job advert posts when
            a job is posted to Hospitality Leaders."
              >
                <div className="row">
                  <div className="col-lg-6">
                    <TextInput
                      label="Name of hotel company"
                      type="text"
                      required={true}
                      name="title"
                    />
                  </div>
                  <div className="col-lg-6">
                    <SelectInput
                      name="client_type_id"
                      label="Hotel type"
                      options={props.ClientTypeOptions}
                      mode="single"
                      required={true}
                      searchable={true}
                    />
                  </div>
                </div>
                <ImageUpload
                  state={state}
                  setState={setState}
                  form={form}
                  isEdit={isEdit}
                  changeFunc={props.updateClient}
                  name="client_images"
                  label="Upload photos of the hotel"
                  description="Upload images of the hotel to display on your
          job posting when you post a job for this client."
                >
                  <Button submit inline size="small">
                    Upload photo
                  </Button>
                </ImageUpload>
                <Quil
                  fieldDescription="A paragraph or two about the hotel. This will be displayed on all job adverts posted."
                  name="description"
                  label="Hotel Description"
                  type="text"
                  placeHolder="Description"
                  required={true}
                />
              </Fieldset>
              <Fieldset title="Hotel address">
                <div className={styles.addressContainer}>
                  <div className="row">
                    <div className=" col-lg-6">
                      <TextInput
                        type="text"
                        label="Address"
                        required={true}
                        name="address_line_1"
                        placeHolder="Address line 1"
                      />
                      <TextInput
                        type="text"
                        required={true}
                        name="address_line_2"
                        placeHolder="Address line 2"
                      />
                      <TextInput
                        type="text"
                        required={true}
                        name="address_line_3"
                        placeHolder="Address line 3"
                      />
                      <TextInput
                        type="text"
                        label="State, province or region"
                        required={true}
                        name="state"
                      />
                    </div>
                    <div className="col-lg-6">
                      <div className={styles.addressContainer}>
                        <TextInput type="text" label="City" required={true} name="city" />
                        <div className="row">
                          <div className="col-6 col-lg-8">
                            <SelectInput
                              name="country_id"
                              label="Country"
                              options={props.countryOptions}
                              mode="single"
                              required={true}
                              searchable={true}
                            />
                          </div>
                          <div className="col-lg-4 col-6">
                            <TextInput
                              type="text"
                              label="Area Code"
                              required={true}
                              name="area_code"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fieldset>
            </div>
          </div>
        </Form>
      </FormProvider>
    </div>
  );
};
